var exports = {
  "JM": "x620889e6--5cc658--form-container",
  "Wt": "x620889e6--5cc658--form-element",
  "Be": "x620889e6--5cc658--form-group",
};

module.exports = exports;
